import React, { useState, useRef, useEffect } from 'react'
import { Popconfirm, Spin } from 'antd'
import LoadingOutlined from '@ant-design/icons/LoadingOutlined'

export default (Component, props) => {
    return ({ onClick, isStopPropagation, confirm, customizeLoading, ...restProps }) => {
        const $this = useRef({
            isUnmount: false,
            isLock: false,
        })
        const [loading, setLoading] = useState(false)

        useEffect(() => {
            return () => {
                $this.current.isUnmount = true
            }
        }, [])

        const handleClick = async e => {
            if (isStopPropagation) {
                e.stopPropagation()
            }
            if ($this.current.isLock) {
                return
            }

            $this.current.isLock = true
            setLoading(true)

            try {
                const result = onClick()
                if (result && result.then) {
                    await result
                }
            } catch (e) {
                console.error('handleClick error', e)
            }

            if ($this.current.isUnmount) {
                return
            }

            setLoading(false)
            $this.current.isLock = false
        }

        if (confirm) {
            return (
                <Popconfirm {...(confirm || {})} onConfirm={handleClick}>
                    <Component loading={loading} {...(props || {})} {...restProps} />
                </Popconfirm>
            )
        }
        if (customizeLoading) {
            return (
                <Spin spinning={loading} indicator={<LoadingOutlined style={{ color: '#999' }} />}>
                    <Component onClick={handleClick} {...(props || {})} {...restProps} />
                </Spin>
            )
        }

        return <Component loading={loading} onClick={handleClick} {...(props || {})} {...restProps} />
    }
}
